import services from './../../services/service'; // Service Class
import MainHeader from './../MainHeader/index.vue'; // Main Header
import MainFooter from './../MainFooter/index.vue'; // Main Footer
let service = new services();

export default {
    name: 'Register',
    data () {
        return {
            users: {},
            user: {},
            states: {},
            cities: {},
            user_type:"bo",
            terms:true,
            disable_btn: false,
            loading:false
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter
     },
    methods: {
        reset() {
            localStorage.removeItem("sp_user");
            localStorage.removeItem("sp_token");
            localStorage.removeItem("sp_token_key");
        },
        
        getStates() {
            service.getStates(this).then(function(data) {
                this.states = data.body;
            })
        },

        getCities(state) {
            service.getCities(this, state).then(function(data) {
                this.cities = data.body;
            })
        },
        reg(){
            this.disable_btn = true;
            this.user.agree = true; ///change 
            var credentials = {
                user_name: this.user.name,
                user_phone: this.user.phone,
                user_email: this.user.email,
                user_address: this.user.address || '',
                user_state: this.user.state || '',
                user_city: this.user.city || '',
                user_password: this.user.password
            }

            let navi = this.$router;
           if(credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null &&
            credentials.user_email != null && credentials.user_password != null) {
                if(this.terms) {
                    this.loading = true; //activate loading
                    service.regUser(this, credentials).then(function(data) {
                        if(data.body.status == 201) {
                            toastr.success("Account Created", 'Success!');
                            //log user in
                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: data.body.data.user_password
                            }
                            service.loginUser(this, credentials).then(response => {
                                if(response.body.status == 200) {
                                    let data = response.body.data;
                                    localStorage.setItem("sp_user", data.user_name); 
                                    localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
                                    localStorage.setItem("sp_token_key", data.user_token_key); 
                                    if(this.user_type == "bo"){
                                        navi.push("create?t=new");
                                    }
                                    else{
                                        navi.push("/?a=tops");
                                    }  
                                    //  navi.push('account');
                                   // location.replace('/')
                                }
                            }).catch((err) => {
                                if(err.status == 404) {
                                    toastr.warning("invalid login credentials", 'Warning!'); 
                                    this.disable_btn = false;
                                }
                            })
                        }else if(data.body.status == 409) {
                            toastr.warning("You already have a Sellpoint Account", 'Warning!');
                            navi.push("login?u=connect");
                            this.disable_btn = false;
                        }
                    })
                }else {
                    toastr.error('Please agree to Terms', 'Warning!');
                    this.disable_btn = false;
                }
        }else {
            toastr.error('Kindly fill all fields', 'Warning!');
            this.disable_btn = false;
        }
    }
    },
    created: function(){
       
    }
}


// WEBPACK FOOTER //
// ./src/pages/Register/script.js